module.exports = __webpack_public_path__ + "static/media/tiktok.f43afb40.svg";